import { CalendarViewModel } from "@views";
import { observer } from "mobx-react-lite";
import React, { FC, useCallback, useMemo } from "react";
import { MembersStore, RoomsStore } from "../../store";
import { Formats, ISearchAreaOption, TFormats, getShortUserName, useStore, useViewModel } from "../../utils";
import { FilterViewModel } from "../filter";
import { FilterOption } from "./FilterOption";
import { SearchAreaOption } from "./options/SearchAreaOption";
import { WhereOption } from "./options/WhereOption";
import { WhoOption } from "./options/WhoOption";

export const Filters: FC = observer(({
}) => {
  const filterViewModel = useViewModel(FilterViewModel);
  const calendarViewModel = useViewModel(CalendarViewModel);
  const membersStore = useStore(MembersStore);
  const roomsStore = useStore(RoomsStore);

  const getFormatOptionAndLabel = useCallback((format: string) => format[0].toUpperCase() + format.slice(1).toLowerCase(), []);
  const membersIds = useMemo(() => membersStore.membersWithCurrentUser.map(member => member.id), [membersStore.membersWithCurrentUser.length]);
  const roomsCabinetNumbers = useMemo(() => roomsStore.data.map(member => member.cabinetNumber), [roomsStore.data.length]);

  const onChangeSearchArea = useCallback((value: ISearchAreaOption[]) => {

    const lastItem = value[value.length - 1];

    if (!!value.length)
      filterViewModel.onUpdateFilters('searchArea',
        // Если выбрали опшен Все или Активные календари, то в массиве value такой опшен будет последним. Если это так, то тогда мы оставляем только его в массиве.
        //  Иначе мы кликнули на один из пользовательских календарей и он тажке добавился последним в массив. Тогда нам надо отфильтровать массив, чтобы остались только пользовательские календари
        lastItem?.mode === 'ACTIVE' || lastItem?.mode === 'ALL'
          ? [lastItem]
          : value.filter(item => item?.mode !== 'ACTIVE' && item?.mode !== 'ALL')
      );
  }, []);

  return (
    <div className="filters-area">
      <FilterOption
        title={'Область поиска'}
        mode="multiple"
        options={filterViewModel.searchAreaOptions}
        value={filterViewModel.filters.searchArea}
        onChange={onChangeSearchArea}
        className="calendars"
        defaultValue={[filterViewModel.searchAreaOptions[0]]}
        getOptionId={(option: ISearchAreaOption) => option.mode}
        renderOption={SearchAreaOption}
        getOptionLabel={(option: ISearchAreaOption) => typeof option.data === 'string' ? option.data : option.data.title}
      />
      <FilterOption
        title='Описание'
        mode="input"
        inputValue={filterViewModel.filters.description}
        onChange={(value: string) => filterViewModel.onUpdateFilters('description', value)}
        placeholder="Ключевые слова, относящиеся к мероприятию"
      />
      <FilterOption
        title='Кто'
        mode="multiple"
        search
        options={membersIds}
        value={filterViewModel.filters.who}
        onChange={(value: number[]) => filterViewModel.onUpdateFilters('who', value)}
        className="who-option"
        placeholder="Укажите участника или организатора"
        placeholderWhenNoFilteredItems='Сотрудников нет'
        getOptionLabel={(option: number) => getShortUserName((membersStore.getMemberById(option)?.fullName))}
        getOptionId={(option: number) => option}
        renderOption={WhoOption}
      />
      <FilterOption
        title={'Где'}
        mode="select"
        options={roomsCabinetNumbers}
        value={filterViewModel.filters.where}
        onChange={(value: number) => filterViewModel.onUpdateFilters('where', value)}
        disabled={filterViewModel.filters.format === Formats.ONLINE}
        renderOption={WhereOption}
        placeholder="Укажите место проведения"
        getOptionLabel={(option: number) => {
          const room = roomsStore.getRoomByCabinetNumber(option);
          return `${room.cabinetNumber} ${room?.conferenceTitle}`;
        }}
      />
      <FilterOption
        title='Формат'
        mode='select'
        value={filterViewModel.filters.format}
        onChange={(value: TFormats) => filterViewModel.onUpdateFilters('format', value)}
        options={Object.values(Formats)}
        renderOption={(item: string) => <>{getFormatOptionAndLabel(item)}</>}
        placeholder="Укажите формат проведения встречи"
        getOptionLabel={getFormatOptionAndLabel}
      />

      <FilterOption
        title={'Дата'}
        mode="date"
        className="interval-option"
        startDate={calendarViewModel.startIntervalOfFilter}
        endDate={calendarViewModel.endIntervalOfFilter}
        isPlaceholderMinDate={!filterViewModel.filters.startInterval}
        isPlaceholderMaxDate={!filterViewModel.filters.endInterval}
        onChangeStartDate={(value: Date) => filterViewModel.onUpdateFilters('startInterval', value)}
        onChangeEndDate={(value: Date) => filterViewModel.onUpdateFilters('endInterval', value)}
      />

      <FilterOption
        title={'Прошедшие встречи'}
        mode="checkbox"
        className="prev-meetings-option"
        value={filterViewModel.filters.isShowPrevMeetings}
        onChange={(value: boolean) => filterViewModel.onUpdateFilters('isShowPrevMeetings', value)}
      />
    </div>
  );
});
